// react-redux imports
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { RootState } from "app/store";
import { setBackgroundColor } from "features/background/backgroundSlice";
import {
  setHeaderAction,
  setHeaderColorMode,
} from "features/header/headerSlice";
import { setIsAuthDialogOpen } from "features/authDialog/authDialogSlice";

import axios from "axios";
import { CalculatorResult } from "features/auth/types";
import { SeparatedWaste } from "features/calculator/householdHabits/householdHabitsSlice";

import { API_URL } from "common/constants/config";

import AuthDialog from "features/authDialog/AuthDialog";
import Container from "./styled-components/Container";
import Summary from "./Summary";
import Sectors from "./Sectors";

function Results() {
  interface LocationState {
    doNotUpdate?: boolean;
  }

  const location = useLocation<LocationState>();
  const [result, setResult] = useState<CalculatorResult>({
    userFootprint: {
      transport: 0,
      energy: 0,
      nutrition: 0,
      householdHabits: 0,
      total: 0,
    },
    averageFootprint: {
      transport: 0,
      energy: 0,
      nutrition: 0,
      householdHabits: 0,
      total: 0,
    },
    equivalences: {
      trees: 0,
      cars: 0,
    },
  });
  const dispatch = useDispatch();
  const upDesktopScreen = useSelector(
    (state: RootState) => state.app.upDesktopScreen
  );

  const isAuthDialogOpen = useSelector(
    (state: RootState) => state.authDialog.isAuthDialogOpen
  );

  const auth = useSelector((state: RootState) => state.auth);
  const calculator = useSelector((state: RootState) => state.calculator);

  function handleAuthDialogSuccess(resultResponse: CalculatorResult) {
    setResult(resultResponse);
    dispatch(setIsAuthDialogOpen(false));
  }

  async function fetchResult() {
    const {
      data: { result: resultResponse },
    } = await axios.get("/calculator/result", {
      baseURL: API_URL,
    });

    setResult(resultResponse);
  }

  async function updateResult() {
    const {
      householdHabits: { separatedWaste: separatedWasteObject },
    } = calculator;
    const separatedWaste = Object.entries(separatedWasteObject).reduce(
      (acc: Array<keyof SeparatedWaste>, cur: [string, boolean]) => {
        const [key, value] = cur;
        if (value) acc.push(key as keyof SeparatedWaste);
        return acc;
      },
      []
    );

    const payload = {
      ...calculator,
      householdHabits: {
        ...calculator.householdHabits,
        separatedWaste,
      },
    };

    const {
      data: { result: resultResponse },
    } = await axios.put("/calculator/result", payload, {
      baseURL: API_URL,
    });

    setResult(resultResponse);
  }

  useEffect(() => {
    dispatch(setBackgroundColor("#ffffff"));
    dispatch(setHeaderColorMode("color"));
    dispatch(setHeaderAction(upDesktopScreen ? "none" : "menu"));
    if (!Object.values(auth).includes(undefined)) {
      if (location.state?.doNotUpdate) fetchResult();
      else updateResult();
    } else dispatch(setIsAuthDialogOpen(true));
  }, []);

  return (
    <Container>
      {isAuthDialogOpen && (
        <AuthDialog successCallback={handleAuthDialogSuccess} haveBackArrow={true} />
      )}
      <Summary
        userFootprint={result.userFootprint.total}
        averageFootprint={result.averageFootprint.total}
        treeEquivalence={result.equivalences.trees}
        carEquivalence={result.equivalences.cars}
      />
      <Sectors result={result} />
    </Container>
  );
}

export default Results;
